export default __webpack_public_path__ + "static/media/urmak-kapak.c1b0ca35.jpg";